import { SET_MESSAGE } from "./const";

export default {

    [SET_MESSAGE](state, message) {
        state.message = message
    },
}